import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import '../layout/sass/_form.scss';

export const FormIndisponivel = () => {
    const toast = useRef(null);

    return (
        <div className="p-d-flex p-jc-center p-ai-center p-p-4" style={{ minHeight: '60vh', width: '100%' }}>
            <Toast ref={toast} position="bottom-right" />
            
            <Card 
                className="p-col-12 p-md-8 p-lg-5 p-shadow-4 p-p-3" 
                style={{ 
                    textAlign: 'center', 
                    borderRadius: '16px',
                    background: 'linear-gradient(145deg, #ffffff, #f8f9fa)',
                    borderTop: '6px solid #e74c3c'
                }}
            >
                <div className="p-mb-3">
                    <i 
                        className="pi pi-exclamation-triangle" 
                        style={{ fontSize: '3.5rem', color: '#e74c3c' }}
                    ></i>
                </div>

                <h2 className="p-mt-0 p-mb-2" style={{ color: '#2c3e50', fontWeight: '700', fontSize: '1.75rem' }}>
                    Solicitações Indisponíveis
                </h2>

                <p style={{ color: '#6c757d', fontSize: '1.1rem', lineHeight: '1.6' }} className="p-px-3 p-mt-2">
                    No momento, o sistema encontra-se fora do período ativo de solicitações ou 
                    <strong style={{ color: '#2c3e50', display: 'block', marginTop: '4px' }}>
                        todas as mudas disponíveis foram esgotadas.
                    </strong>
                </p>

                <div className="p-mt-4 p-pt-3" style={{ borderTop: '1px solid #e9ecef', color: '#95a5a6', fontSize: '0.875rem' }}>
                    Acompanhe os canais oficiais da Prefeitura para informações sobre as próximas etapas e edições do projeto.
                </div>
            </Card>
        </div>
    );
};